<template>

<Modal @close="closeModale">
    <template #header >
        واریز {{$coinLabel[relatedCoin[0]]}}
    </template>

    <template #body >
                          <template>
                <label for="" class="selectd-net-lable">
                    <div class="selectd-net" @click="drop = !drop">
                        <span v-if="selected_net">{{selected_net}}</span>
                        <span v-else>انتخاب شبکه</span>
         
                    </div>
                                   <p v-if="!selected_net">لطفا برای ادامه ی واریز شبکه ی مورد نظر را  انتخاب کنید</p>
                    <div class="dropdown" v-if="drop">
                        <div v-for="(net , index) in nets" :key="index" @click="selectFun(index)">
                            {{net.tokenType}}
                        </div>
                    </div>
                    
                </label>
               
            </template>



          <div class="body" v-if="selected_net">
                <p class="text">لینک زیر آدرس کیف پول شما می باشد. برای واریز کوین می توانید از این آدرس یا اسکن کد زیر استفاده کنید.</p>
                <div class="barcode"> <img :src="'data:image/png;base64,'+qrCode" alt="" width="150" height="150" /></div>
                <div class="point"><img class="icon" src="../../../assets/icon/caution.svg"/><div>توجه کنید که واریز به هر آدرس دیگری جز این آدرس موجب از دست رفتن دارایی شما می شود. این عمل بازگشت‌ پذیر نخواهد بود و دریک هیچ مسولیتی را در این باره قبول نخواهد کرد.</div></div>
                <LabelInput default="" :ltr="true" :copy="true" :label='address'/>

  <div class="check">
                     <p class="error-p" v-if="!enable && !!selected_net">
                 در حال حاضر واریز به شبکه مورد نظر مقدور نیست
            </p>
            </div>

 <input class="normal-input" type="text" v-if="txIdIsNeeded" v-model="txid" placeholder="شناسه تراکنش">
     <button  @click.prevent="checkWallet" :disabled="(txIdIsNeeded && !txid && !enable) || selected_net==''">ثبت</button>
          </div>

    </template>




   
</Modal>

</template>

<script>
import Modal from './Modal'
export default {
  name: 'CryptoDepsoit',
  components:{
      Modal
  },
  
  props:{
      crypto:Object,
          relatedCoin: {
            default: ''
        },
        exchange: {
            default: false
        },
        nets: {
            default: {}
        }
  },
  data() {
    return {
       amount: '',
            address: '',
            qrCode: '',
            tag: '',
            txid: '',
            token: false,
            alertLink: false,
            drop: false,
            selected_net: "",
            txIdIsNeeded: false,
            enable : false
    };
  },
   methods: {

        closeModale() {
            this.$emit('closeModaleEmit', this.close)
        },
        changeNetwork(e) {
            this.token = e
            this.getQR()
        },
        Copy(e) {
            navigator.clipboard.writeText(e)
            alert('آدرس کپی شد')
        },
        async checkWallet() {
            this.state.loading = true
            // const token = this.token ? 'ERC20' : 'TRC20'
            let query = {
                relatedCoin: this.relatedCoin[0],
                tokenType : this.selected_net,
                walletType : (this.exchange ? 'EXCHANGE' : 'P2P')
            }
            if (this.txIdIsNeeded) {
                query.txid = this.txid
            }
            const res = await this.$axios.get('/wallets/check-confirmed-transaction', {
                params: query
            })
            let text
            if (res.baseDTO.amount) {
                text = `مقدار ${this.$toLocal(res.baseDTO.amount) || 0} ${this.$coinLabel[this.relatedCoin[0]]} واریز شده و تایید ${res.baseDTO.transactionIsDone ? 'شده' : 'نشده'}`
            } else {
                text = 'مقدار واریزی شناسایی نشد'
            }
            this.$error('', text, res.baseDTO.transactionIsDone ? 'success' : 'info')
        },
        selectFun(index) {
            this.selected_net = this.nets[index].tokenType
            this.txIdIsNeeded = this.nets[index].txIdIsNeeded
            this.enable = this.nets[index].isDepositEnable || true
            this.drop = false
            if(this.enable) {
                this.getQR()
            }
            

        },
        async getQR() {
            this.state.loading = true
            const token = this.selected_net
            let params = {
                relatedCoin: this.relatedCoin[0]
            }
            if (this.relatedCoin[0] === 'TETHER') {
                params.tokenType = token
            }
            const res = await this.$axios('/wallets/customer/wallet-address?walletType=' + (this.exchange ? 'EXCHANGE' : 'P2P') + '&tokenType=' + token, {
                params
            }).catch(() => {
                this.closeModale()
            })
            if (res) {
                this.address = res.baseDTO.address
                this.qrCode = res.baseDTO.qrCode
                this.tag = res.baseDTO.tag
            }
        }
    },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.selectd-net-lable {
    position: relative;
    z-index: 2;
display: flex;
flex-direction: column;
    .selectd-net {
        cursor: pointer;
        background: transparent;
          border: 1px solid #279bc0;
    border-radius: 4px;
        height: 38px;
        width: 100%;
        color: var(--font-strong);
        box-sizing: border-box;
        padding: 0 10px;
        display: flex;
        
        align-items: center;
    }

    .dropdown {
      display: flex;
      flex-direction: column;
      gap: 15px;
      align-self: center;
        position: absolute;
        width: 90%;
        top: 48px;
        background: #001E3D !important;
            border: 1px solid #279bc0;
    border-radius: 4px;
        padding: 10px;

        div {
            cursor: pointer;
        }
    }
}


.point{
  display: flex;
  column-gap: 5px;
  align-items: flex-start;
  color: #FBFBFD;
  font-size: clamp(12px,1.2vw,14px);
}
.body{
  position: relative;
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  min-height: 150px;
}
button{
  background: linear-gradient(181.54deg, #1199FA 1.31%, #123249 180.79%);
  border-radius: 4px;
  width: 100%;
  color: white;
  padding: 8px 0px;
}
.barcode{
    display: flex;
    justify-content: center;
    padding: 10px 0px 10px 0px;
}

.text{
  font-size: clamp(14px,1.5vw,16px);
}
</style>
